import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { FreeRequests, FreeRequestStatus } from '../model/types';

const SUBSCRIPTION = `/api/admin/subscription`;

export const FREE_REQUESTS_KEY = 'free-subscription-requests';

export const useGetFreeRequests = (status: FreeRequestStatus | 'all') => {
	return useQuery<FreeRequests>(
		[FREE_REQUESTS_KEY, status],
		async () => {
			const { data } = await axios.get(`${SUBSCRIPTION}/free-requests`, {
				params: status === 'all' ? {} : { status },
			});
			return data;
		},
		{
			refetchOnWindowFocus: false,
			// Заявки приходят редко и разбираются руками: чаще опрашивать
			// незачем, но и оставлять список вчерашним нельзя — менеджеров
			// несколько, и одну заявку может закрыть кто-то другой.
			refetchInterval: 60000,
		}
	);
};

export const useApproveFreeRequest = () => {
	const queryClient = useQueryClient();

	return useMutation<unknown, unknown, string>(
		async uuid => {
			const { data } = await axios.post(
				`${SUBSCRIPTION}/free-requests/${uuid}/approve`
			);
			return data;
		},
		{
			onSuccess: () => queryClient.invalidateQueries(FREE_REQUESTS_KEY),
		}
	);
};

export const useRejectFreeRequest = () => {
	const queryClient = useQueryClient();

	return useMutation<unknown, unknown, { uuid: string; comment: string }>(
		async ({ uuid, comment }) => {
			const { data } = await axios.post(
				`${SUBSCRIPTION}/free-requests/${uuid}/reject`,
				{ comment: comment || null }
			);
			return data;
		},
		{
			onSuccess: () => queryClient.invalidateQueries(FREE_REQUESTS_KEY),
		}
	);
};
